// 这里是去掉了JSB的在线图片加载逻辑，理论上来说如果由服务端转码好再水合，会处理的更快一些

import React from 'react';
// import { processWebp } from '../../tools/image-utils';

type WebImagePropType = {
  altProp: string;
  className: string;
  href: string;
  origin_src: string;
  thumb_src: string;
  width: string | number;
  height: string | number;
  // 这个index用来计算当前图片是第几张，在uselocal的时候需要传递
  index: number;
  groupId: string;
} & Partial<DefaultProps>;

const ImageStatus = {
  NONE: 0,
  LOADING: 1,
  SUCCESS: 2,
  FAIL: 3,
};

const ImageSrcType = {
  LOCAL: 0,
  CDN: 1,
  CDN_THUMB: 2,
};

// 假设用户看到的第一屏图片，按照800px的高也是顶多5张张图
// 常规来说 5张图已经覆盖第一屏和第二屏的信息
const FirstScreenImageCounts = 3;

interface WebImageStateType {
  src: string;
  srcType: number;
  status: number;
}

type DefaultProps = Readonly<typeof defaultProps>;

const defaultProps = {
  style: {},
  config: {
    urlPrefix: '',
    imgType: '',
    groupId: '',
  },
  onClick: (src: string, index: number, altProp: string) => {
    //
  },
};

export default class WebImage extends React.Component<
  WebImagePropType,
  WebImageStateType
> {
  static defaultProps: DefaultProps = defaultProps;

  state: WebImageStateType = {
    src: '',
    srcType: ImageSrcType.LOCAL,
    status: ImageStatus.NONE,
  };

  private el: any;

  private _img: HTMLImageElement | any;

  private anchor: any;

  private setTimeoutLoadImage: any;

  constructor(props: WebImagePropType) {
    super(props);

    // 如果是懒加载，那么首次渲染数据源为空，起占位符作用

    // 非懒加载，那么直接计算并调用当前的加载方式，这里数值可以直接写state上
    const { thumb_src: thumbSrc } = props;

    // 端外的兜底逻辑，只先渲染假设的第一屏图片
    // 优先渲染三张，后续延迟渲染
    this.state.status = ImageStatus.LOADING;

    // 由于本组件应用于服务端渲染，所以封图是默认全渲染的（封图特别小）
    this.state.src = thumbSrc;
    this.state.srcType = ImageSrcType.CDN_THUMB;
  }

  componentDidMount() {
    // 页面did之后会立刻开始异步拉取大图，这里放在didMount是因为拉取大图的Image对象，需要浏览器环境
    const { index } = this.props;
    if (index < FirstScreenImageCounts) {
      this.asyncLoadImage();
    } else {
      this.setTimeoutLoadImage = setTimeout(() => {
        this.setCdnSrc();
        // 因为平均渲染时间200-300ms，就算后续有40张图，也会在1000ms内渲染完成
      }, index * 20 + 300);
    }

    if (this.anchor) {
      // 清除锚点上的信息，因为hydrate以原dom结构为主，这里需要清理掉，比较tick，后续看有没有更优雅的清洗方式
      this.anchor.href = '';
    }
  }

  componentWillUnmount() {
    // 防止内存泄漏
    clearTimeout(this.setTimeoutLoadImage);
    this.resetImgLoad();
  }

  reloadImage: () => void = () => {
    const { status } = this.state;
    // 如果未加载，或者加载失败，可以手动触发二次加载
    if (status !== ImageStatus.NONE && status !== ImageStatus.FAIL) {
      return;
    }

    this.setCdnSrc();
  };

  resetImgLoad: () => void = () => {
    if (this._img) {
      this._img.onload = null;
      this._img.onerror = null;
      this._img = null;
    }
  };

  // 加载远端原始图片
  asyncLoadImage: () => void = () => {
    this._img = new Image();
    this._img.src = this.props.origin_src;
    this._img.onload = () => {
      // 图片后台加载成功后，替换当前展现的内容
      this.setState({
        src: this.props.origin_src,
        srcType: ImageSrcType.CDN,
        status: ImageStatus.SUCCESS,
      });
      this.resetImgLoad();
    };
    this._img.onerror = () => {
      // 只要远端大图失败，就认为是彻底失败
      this.setState(
        {
          srcType: ImageSrcType.CDN,
        },
        this.handleImageError,
      );
      this.resetImgLoad();
    };
  };

  setCdnSrc: () => void = () => {
    this.setState({
      // 这里只是强制纠正状态
      status: ImageStatus.LOADING,
      src: this.props.thumb_src,
      srcType: ImageSrcType.CDN_THUMB,
    });
    this.asyncLoadImage();
  };

  handleImageClick: (e: any) => void = e => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    const { status, srcType, src } = this.state;
    const { onClick, index, altProp = '' } = this.props;

    switch (status) {
      case ImageStatus.SUCCESS:
        // 图片加载后，点击是访问图片查看器
        if (onClick) {
          onClick(src, index, altProp);
        }
        // 如果大图没有加载出来，会同时重试
        if (srcType === ImageSrcType.CDN_THUMB) {
          this.asyncLoadImage();
        }
        break;
      case ImageStatus.NONE:
      case ImageStatus.FAIL:
        // 如果图片点击时还没加载出来，那么优先走加载逻辑
        // 如果图片加载失败，那么显示重试逻辑
        this.reloadImage();
        break;
      default:
        // 如果加载中或者加载失败，就不做响应
        break;
    }
  };

  handleImageLoad: () => void = () => {
    const { srcType } = this.state;
    // 只有远端大图加载成功，才认为是完全成功；缩略图加载成功不做修改
    if (srcType === ImageSrcType.CDN) {
      // 如果图片加载结束，那么应该去掉图片加载状态
      this.setState({
        status: ImageStatus.SUCCESS,
      });
    }
  };

  handleImageError: () => void = () => {
    const { srcType } = this.state;
    // 只要大图加载失败，那么就彻底失败
    if (srcType === ImageSrcType.CDN) {
      this.setState({
        src: '',
        status: ImageStatus.FAIL,
      });
    }
  };

  render() {
    const {
      className,
      style,
      width = 1,
      height = 0,
      altProp = '',
    } = this.props;
    const { src, status } = this.state;

    // 加载失败有失败的样式，加载中有加载中的样式
    const paddingBottom = `${(Number(height) / Number(width)) * 100}%`;
    // 为了兼容iOS，这里将所有webp格式的图片都给拍成jpg
    // const noWebpSrc = processWebp(src);
    return (
      <div
        ref={(e: any) => (this.anchor = e)}
        className={className}
        style={{
          ...style,
          paddingBottom,
        }}
        onClick={this.handleImageClick}>
        <img
          alt={altProp}
          ref={(e: any) => (this.el = e)}
          src={src}
          onLoad={this.handleImageLoad}
          onError={this.handleImageError}
          style={{
            opacity: status === ImageStatus.FAIL ? 0 : 1,
            // pointerEvents: 'auto',
          }}></img>
      </div>
    );
  }
}
